<template lang='pug'>
  .fpui-input-text.fpui-textarea
    .row
      .fpui-input-label-container(@click='focus', :class='labelClass', v-if='label')
        .required-container(v-if='required')
          i.fpui.fpui-required
        span {{ label | translate }}
        fpui-helper(v-if='helper', :text="helper | translate")
      .fpui-input-content.vcenter(:class='inputClass')
        textarea(ref='textarea', v-model='model', :class='{ error: error }', :placeholder='placeholder | translate')
</template>

<script>

export default {
  props: {
    value: { type: String },
    error: { type: Boolean },
    label: { type: String },
    placeholder: { type: String },
    labelSize: { type: Number, default: 3 },
    labelVerticalAlign: { type: Boolean, default: false },
    withPadding: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    helper: { type: String }
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    inputClass () {
      let className = []
      let size = 12
      if (this.label) size -= this.labelSize
      className.push(`col-xs-${size}`)
      if (this.withPadding) className.push('with-padding')
      return className.join(' ')
    },
    labelClass () {
      let className = [`col-xs-${this.labelSize}`]
      if (this.withPadding) className.push('with-padding')
      if (this.labelVerticalAlign) className.push('vcenter')
      return className.join(' ')
    }
  },
  mounted () { this.$refs.textarea.addEventListener('keydown', this.onKeyDown) },
  beforeDestroy () { this.$refs.textarea.removeEventListener('keydown', this.onKeyDown) },
  methods: {
    focus () { this.$refs.textarea && this.$refs.textarea.focus() },
    onKeyDown (e) {
      if (e.keyCode === 13 && e.metaKey) {
        this.$emit('submit')
      }
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-textarea {
  position:relative;
  .fpui-input-label-container {
    padding-left: 0;
    cursor: pointer;
    .required-container {
      display: inline-block;
      margin-right: 7px;
      width: 15px;
      vertical-align: middle;
      font-size: 22px;
      text-align: center;
      color: @blue;
      border-radius: 50%;
    }
  }
  .fpui-input-content {
    &:not(.with-padding) {
      padding: 0;
    }
    textarea {
      width: 100%;
      border-radius: 2px;
      background: #FFF none repeat scroll 0% 0%;
      padding:8px;
      min-height:80px;
      border: 1px solid #dedede;
      font-size: 1em;
      font-weight: 300;
      letter-spacing: 1px;
      outline: none;
      &:focus {
        border-color: @blue;
      }
      &:not(.disabled) {
        transition: 200ms linear;
      }
      &.error {
        border-color: @red;
      }
    }
  }
}
</style>
